module.exports = __webpack_public_path__ + "static/media/logo.f5b4bfd1.jpg";